var v1 = require('./v1');
var v4 = require('./v4');

var uuid = v4;
uuid.v1 = v1;
uuid.v4 = v4;

module.exports = uuid;



//////////////////
// WEBPACK FOOTER
// ../node_modules/next/node_modules/uuid/index.js
// module id = 52
// module chunks = 0 1 2 3 4 5 6 7 8 11 12 13 14 15 16 19